/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Message } from 'components';
import { useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { useGetFormTokenQuery, useGetRenewInformationQuery } from 'store/api/version-api.slice';

import { PaymentStatusResult } from '../dashboard/components/PaymentInformation';
import { RenewMemberFileCard } from './components';
import RenewMemberNewCard from './components/RenewMemberNewCard';
import { styles } from './styles/renewMember.styles';

const RenewMemberRoute = () => {
	const params = useParams();

	const [paymentStatus, setPaymentStatus] = useState('');

	const { data: renewInfo = {}, isLoading: isRenewLoading } = useGetRenewInformationQuery({
		portalId: params.portal_id,
		contactId: params.contact_id
	});

	const { data: formToken, isLoading: isFormTokenLoading } = useGetFormTokenQuery();

	const renewInformation = useMemo(() => {
		return {
			...renewInfo,
			...(formToken && { form_token: formToken })
		};
	}, [formToken, renewInfo]);

	if (isRenewLoading || isFormTokenLoading)
		return (
			<Box sx={styles.centered}>
				<CircularProgress size={100} sx={styles.fabProgress} />
			</Box>
		);

	return (
		<Box sx={styles.root}>
			<CssBaseline />
			<Container maxWidth="lg">
				<Grid container spacing={2}>
					<Grid item xs={12}>
						<Typography component={'span'} variant="h3" color="primary" sx={styles.title}>
							RENEW MEMBERSHIP
						</Typography>
						{['SUCCESS', 'ERROR'].includes(paymentStatus) ? (
							<Paper elevation={2} sx={styles.paper}>
								<PaymentStatusResult status={paymentStatus} />
							</Paper>
						) : (
							<>
								{renewInformation?.card_details && (
									<Box sx={styles.bottomOffset}>
										<RenewMemberFileCard
											setPaymentStatus={setPaymentStatus}
											renewInfo={renewInformation}
											params={params}
										/>
									</Box>
								)}

								<RenewMemberNewCard
									setPaymentStatus={setPaymentStatus}
									renewInfo={renewInformation}
									params={params}
								/>
							</>
						)}
						<Message />
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};

export default RenewMemberRoute;
